import {inject} from '@angular/core';
import {tap} from 'rxjs/operators';
import {HttpInterceptorFn, HttpRequest, HttpResponse} from '@angular/common/http';
import {AuthApiService} from '../../Services/Api/Auth/auth-api.service';
import {ApiResponse} from '../../Services/Api/base-api.service';
import {SessionManagerService} from '../../Services/Shared/session-manager.service';
import {I18nManagerService} from '../../Services/Shared/i18n-manager.service';
import {UserSessionDto} from '../../Models/User/user-session.interface';
import packageJson from '@packageJson';

export const authInterceptor: HttpInterceptorFn = (req, next) => {

  if (req.url.includes('assets/')) {
    return next(req);
  }

  const auth = inject(AuthApiService);
  const i18n = inject(I18nManagerService);
  const sessionManager = inject(SessionManagerService);

  const commonHeaders: Record<string, string> = {
    Accept: 'application/json',
    'Accept-Language': i18n.getLanguage(),
    'X-App-Version': packageJson.version,
    'X-App-Identifier': 'io.roocket.yurestv2',
  };

  const user: UserSessionDto | null = auth.getUserSession();

  const cloned: HttpRequest<unknown> = !auth.userIsLogIn() || !user
    ? req.clone({setHeaders: commonHeaders})
    : req.clone({
      setParams: {'user-key': String(user.id)},
      setHeaders: {...commonHeaders, Authorization: user.token},
    });

  return next(cloned).pipe(tap((evt) => {
    const body: ApiResponse | null = evt instanceof HttpResponse ? (evt.body as ApiResponse | null) : null;

    if (body?.status === -1) {
      sessionManager.handleSessionExpired(true);
    }
  }));
};
